import { render, staticRenderFns } from "./LoggerManualsPage.vue?vue&type=template&id=360f5ba4&"
import script from "./LoggerManualsPage.vue?vue&type=script&lang=ts&"
export * from "./LoggerManualsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports